import { EnvName } from 'utils/api';

export type IEnv = Record<EnvName, boolean>;

export enum FeatureFlagId {
	TEST_FF = 'testFF',
	FGA_MAPPINGS = 'fgaMappings',
	SSO_OIDC_GROUP_MAPPING = 'SSO_OIDC_GROUP_MAPPING',
	PRESERVE_QUERY_PARAMS = 'ssoSuitePreserveQueryParams',
	JIT_CARD = 'ssoSuiteJitCard',
	SHOW_SAVE_WHEN_UNTESTED = 'showSaveWhenUntested',
	SKIP_SAML_CERT_VALIDATION = 'skipSamlCertValidation',
	HIDE_SSO_DELETE = 'ssoSuiteHideSsoDelete',
	SSO_SUITE_AUDIT = 'SSO_SUITE_AUDIT'
}

export interface IFeatureFlag {
	id: FeatureFlagId;
	env: Partial<IEnv>;
}

export interface IReqFeatureFlags {
	features: {
		flag: string;
		defaultVal: boolean;
	}[];
}

export interface IResFeatureFlags {
	features: Record<string, boolean | null | undefined>;
}

export interface IServerFeatureFlags {
	features: Record<FeatureFlagId, boolean | null | undefined>;
}

export const QUERY_FF_PREFIX = 'feature';
